// CustomConfirmationView.js
import { TbAlertCircle } from 'react-icons/tb';
import ActionButton from '../custom_components/CustomButtons/ActionButton/ActionButton';
import './CustomConfirmationView.css';

const CustomConfirmationView = ({
    title,
    message,
    onConfirm,
    onCancel,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    isButtonDisabled = false,
}) => {
    return (
        <div className="custom-confirmation-view-container">
            <div className="custom-confirmation-view-title">
                <TbAlertCircle style={{ fontSize: 22, color: '#d32f2f' }} />
                <span>{message}</span>
            </div>

            {/* {message && (
                <div className="custom-confirmation-view-message">
                    {message}
                </div>
            )} */}

            <div className="custom-confirmation-view-actions">
                <ActionButton
                    onClick={onCancel}
                    label={cancelLabel}
                    btnType="outlined"
                />
                <ActionButton
                    btnDisable={isButtonDisabled}
                    onClick={onConfirm}
                    label={confirmLabel}
                    btnType="primary"
                />
            </div>
        </div>
    );
};

export default CustomConfirmationView;
